import { tokenStorage } from "@becon-team/becon-fe-lib/my-axios";

import { localStorageKeyToken } from "utils/(localStorage)";

import { platform } from "./platform";

const SET_AUTH = "setAuth";

export const setAuth = async ({ user_id, user_nickname }: { user_id: string; user_nickname: string }) => {
  const token = await tokenStorage.getTokenInLocalStorage(localStorageKeyToken);

  if (!token) {
    throw new Error("`token` is undefined.");
  }

  const tokenInfo = JSON.stringify({
    access_token: token.accessToken,
    refresh_token: token.refreshToken,
    user_nickname,
    user_id,
  });
  switch (platform) {
    case "android":
      try {
        window.Becon.requestAction(SET_AUTH, SET_AUTH, tokenInfo);
      } catch (err) {
        alert(`android error -> ${err}`);
      }
      break;
    case "ios":
      try {
        window.webkit.messageHandlers.setAuth.postMessage(tokenInfo);
      } catch (err) {
        alert(`ios error -> ${err}`);
      }
      break;
  }
};
